<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="single_row_div" width="900">
    <div class="pstn_content">
      <div class="input_single">
        <div class="font_style_set">公众号名称:</div>
        <Input v-model="channelName" class="input_content" placeholder="请输入公众号名称" style="width:65%"/>
      </div>
      <div class="input_single">
        <div class="font_style_set">微信AppID(开发者ID):</div>
        <Input v-model="channelAppId" readonly class="input_content"/>
      </div>
      <div class="input_single">
        <div class="font_style_set">开发者秘钥(AppSecret):</div>
        <Input v-model="channelAppSecret"  class="input_content" />
      </div>
      <div class="input_single" v-if="false">
        <div class="font_style_set">消息加密密钥(EncodingAESKey):</div>
        <Input v-model="channelKey"  class="input_content"/>
      </div>
      <div class="input_single">
        <div class="font_style_set">URL:</div>
        <Input v-model="channelURL" readonly class="input_content"/>
      </div>
      <div class="input_single">
        <div class="font_style_set">Token:</div>
        <Input v-model="channelWxToken" readonly class="input_content"/>
      </div>
     <div class="input_single">
        <div class="font_style_set">分时段:</div>
        <Select class="input_content" :transfer="true" v-model="channelPeriod" placeholder="请选择是否启用分时段业务">
          <Option :value="'0'">关闭</Option>
          <Option :value="'1'">开启</Option>
        </Select>
        <div class="fixed_operation_btn">
        <Tooltip class="tips_font" placement="left" style="margin-top:-3px;">
                      <div slot="content">
                          <p>分时段功能需要在</p>
                          <p>(系统管理->时间定义)或(系统管理->CTI配置->热线号码->时间定义)</p>
                          <p>中配置后生效</p>
                      </div>
                    <img src="../../../assets/image/homeAsk.png"/>
        </Tooltip>
        </div>
      </div>


<!-- 不开启分时段 -->
      <div class="input_single" v-if="channelPeriod == '0'">
        <div class="font_style_set">分配策略:</div>
          <Select class="input_content" :transfer="true" v-model="channelAllocatStrategy" placeholder="请选择分配策略">
            <Option v-for="item in strategyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
      </div>
      <div class="input_single" v-if="channelPeriod == '0'">
        <div class="font_style_set">分配类型:</div>
          <Select class="input_content" :transfer="true" v-model="channelAllocatType">
            <Option :value="'1'" >导航菜单</Option>
            <Option :value="'2'" >员工</Option>
          </Select>
        </div>
      </div>
      <div class="input_single" v-if="channelPeriod == '0' && channelAllocatType == '1'">
        <div class="font_style_set"><span class="span_must">*</span>分配导航菜单:</div>
          <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelAllocatNavList" multiple placeholder="请选择导航菜单" clearable>
            <Option v-for="item in channelNavList" :value="item.id" :key="item.id">{{ item.navName }}</Option>
          </Select>
      </div>
      <div class="input_single" v-if="channelPeriod == '0' && channelAllocatType == '2'">
        <div class="font_style_set"><span class="span_must">*</span>分配员工:</div>
          <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelAllocatEmpList" multiple placeholder="请选择员工" clearable>
            <Option v-for="item in employeeList" :value="item.agentNo" :key="item.agentNo">{{ item.agentNo }}</Option>
          </Select>
      </div>
      <!-- 开启分时段 -->
      <Tabs v-if="channelPeriod == '1'">
            <TabPane label="工作时间">
                  <div class="input_single">
                    <div class="font_style_set">分配策略:</div>
                      <Select class="input_content" :transfer="true" v-model="channelWorkStrategy" placeholder="请选择分配策略">
                        <Option v-for="item in strategyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                  </div>
                  <div class="input_single">
                    <div class="font_style_set">分配类型:</div>
                      <Select class="input_content" :transfer="true" v-model="channelWorkType">
                        <Option :value="'1'" >导航菜单</Option>
                        <Option :value="'2'" >员工</Option>
                      </Select>
                  </div>
                  <div class="input_single" v-if="channelWorkType == '1'">
                    <div class="font_style_set"><span class="span_must">*</span>分配导航菜单:</div>
                      <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelWorkNavList" multiple placeholder="请选择导航菜单" clearable>
                        <Option v-for="item in channelNavList" :value="item.id" :key="item.id">{{ item.navName }}</Option>
                      </Select>
                  </div>
                  <div class="input_single" v-if="channelWorkType == '2'">
                    <div class="font_style_set"><span class="span_must">*</span>分配员工:</div>
                      <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelWorkEmpList" multiple placeholder="请选择员工" clearable>
                        <Option v-for="item in employeeList" :value="item.agentNo" :key="item.agentNo">{{ item.agentNo }}</Option>
                      </Select>
                  </div>
            </TabPane>
            <TabPane label="下班时间">
                <div class="input_single">
                  <div class="font_style_set">分配策略:</div>
                    <Select class="input_content" :transfer="true" v-model="channelHomeStrategy" placeholder="请选择分配策略">
                      <Option v-for="item in strategyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="input_single">
                    <div class="font_style_set">分配类型:</div>
                      <Select class="input_content" :transfer="true" v-model="channelHomeType">
                        <Option :value="'1'" >导航菜单</Option>
                        <Option :value="'2'" >员工</Option>
                      </Select>
                </div>
                <div class="input_single" v-if="channelHomeType == '1'">
                  <div class="font_style_set"><span class="span_must">*</span>分配导航菜单:</div>
                    <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelHomeNavList" multiple placeholder="请选择导航菜单" clearable>
                      <Option v-for="item in channelNavList" :value="item.id" :key="item.id">{{ item.navName }}</Option>
                    </Select>
                </div>
                <div class="input_single" v-if="channelHomeType == '2'">
                  <div class="font_style_set"><span class="span_must">*</span>分配员工:</div>
                    <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelHomeEmpList" multiple placeholder="请选择员工" clearable>
                      <Option v-for="item in employeeList" :value="item.agentNo" :key="item.agentNo">{{ item.agentNo }}</Option>
                    </Select>
                </div>
            </TabPane>
            <TabPane label="节假日">
                  <div class="input_single">
                    <div class="font_style_set">分配策略:</div>
                      <Select class="input_content" :transfer="true" v-model="channelHolidayStrategy" placeholder="请选择分配策略">
                        <Option v-for="item in strategyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                  </div>
                  <div class="input_single">
                    <div class="font_style_set">分配类型:</div>
                      <Select class="input_content" :transfer="true" v-model="channelHolidayType">
                        <Option :value="'1'" >导航菜单</Option>
                        <Option :value="'2'" >员工</Option>
                      </Select>
                  </div>
                  <div class="input_single" v-if="channelHolidayType == '1'">
                    <div class="font_style_set"><span class="span_must">*</span>分配导航菜单:</div>
                      <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelHolidayNavList" multiple placeholder="请选择导航菜单" clearable>
                        <Option v-for="item in channelNavList" :value="item.id" :key="item.id">{{ item.navName }}</Option>
                      </Select>
                  </div>
                  <div class="input_single" v-if="channelHolidayType == '2'">
                    <div class="font_style_set"><span class="span_must">*</span>分配员工:</div>
                      <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelHolidayEmpList" multiple placeholder="请选择员工" clearable>
                        <Option v-for="item in employeeList" :value="item.agentNo" :key="item.agentNo">{{ item.agentNo }}</Option>
                      </Select>
                  </div>
            </TabPane>>
      </Tabs>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
      name: "EditpublicPop",
      props: {
        showeditpublic: Boolean,
        searchId: String,
      },
      data(){
        return {
          channelURL:'',
          channelAppId:'',
          channelAppSecret:'',
          channelKey:'',
          channelWxToken:'',
          model:false,
          title:'编辑公众号',
          channelName:'', //名称
          channelPeriod: '0', //是否分时段 0不开启 1开启
          channelAllocatType: '1', //分配类型，1导航菜单、2员工
          channelAllocatStrategy:'1', //不开启分时段分配策略
          channelAllocatNavList:'', //不开启分时段分配策略
          channelAllocatEmpList:[], //不开启分时段分配策略
          // 开启分时段策略
          channelWorkStrategy:'1', //上班
          channelWorkNavList:[], //上班
          channelWorkEmpList:[], //上班
          channelWorkType: '1', //分配类型，1导航菜单、2员工

          channelHomeStrategy:'1', //下班
          channelHomeEmpList:[], //下班
          channelHomeNavList:[], //下班
          channelHomeType: '1', //分配类型，1导航菜单、2员工

          channelHolidayStrategy:'1',//节假日
          channelHolidayEmpList:[],//节假日
          channelHolidayNavList:[],//节假日
          channelHolidayType: '1', //分配类型，1导航菜单、2员工

          strategyList:[{id: '1', 'name': '随机分配'},{id: '2', 'name': '上次服务优先分配'},{id: '3', 'name': '当前会话数量最少分配'},{id: '4', 'name': '技能等级优先分配'}],
          channelNavList: [],
          employeeList:[],
        }
      },
      methods:{
        cancel:function () {
          this.$emit("closeeditpublic",false)
        },
        save:function () {
          //未开启分时段
          if(this.channelPeriod === '0'){
            if(this.channelAllocatType === '1' && !this.channelAllocatNavList.toString()){
              this.$Modal.info({
                title:'提示',
                content:"分配导航菜单不能为空"
              });
              return false;
            }
            if(this.channelAllocatType === '2' && !this.channelAllocatEmpList.toString()){
              this.$Modal.info({
                title:'提示',
                content:"分配员工不能为空"
              });
              return false;
            }
          }else{
            //开启分时段
            if(this.channelWorkType === '1' && !this.channelWorkNavList.toString()){
              this.$Modal.info({
                title:'提示',
                content:"工作时间分配导航菜单不能为空"
              });
              return false;
            }
            if(this.channelWorkType === '2' && !this.channelWorkEmpList.toString()){
              this.$Modal.info({
                title:'提示',
                content:"工作时间分配员工不能为空"
              });
              return false;
            }

            if(this.channelHomeType === '1' && !this.channelHomeNavList.toString()){
              this.$Modal.info({
                title:'提示',
                content:"下班时间分配导航菜单不能为空"
              });
              return false;
            }
            if(this.channelHomeType === '2' && !this.channelHomeEmpList.toString()){
              this.$Modal.info({
                title:'提示',
                content:"下班时间分配员工不能为空"
              });
              return false;
            }

            if(this.channelHolidayType === '1' && !this.channelHolidayNavList.toString()){
              this.$Modal.info({
                title:'提示',
                content:"节假日分配导航菜单不能为空"
              });
              return false;
            }
            if(this.channelHolidayType === '2' && !this.channelHolidayEmpList.toString()){
              this.$Modal.info({
                title:'提示',
                content:"节假日分配员工不能为空"
              });
              return false;
            }
          }
          let param = {
            channelKey:this.channelKey,
            channelAppSecret:this.channelAppSecret,
            "id": this.searchId,
            "channelName": this.channelName,
            "channelPeriod": this.channelPeriod,
            "channelAllocatStrategy": this.channelPeriod == "0" ? this.channelAllocatStrategy : "",
            "channelAllocatList": this.channelPeriod == "0" ? "{'list':'"+ (this.channelAllocatType == '1' ? this.channelAllocatNavList : this.channelAllocatEmpList) +"','type':'"+this.channelAllocatType+"'}" : "{}",
            "channelWorkStrategy": this.channelPeriod == "1" ? this.channelWorkStrategy : "",
            "channelWorkList": this.channelPeriod == "1" ? "{'list':'"+ (this.channelWorkType == '1' ? this.channelWorkNavList : this.channelWorkEmpList) +"','type':'"+this.channelWorkType+"'}" : "{}",
            "channelHomeStrategy": this.channelPeriod == "1" ? this.channelHomeStrategy : "",
            "channelHomeList": this.channelPeriod == "1" ? "{'list':'"+ (this.channelHomeType == '1' ? this.channelHomeNavList : this.channelHomeEmpList) +"','type':'"+this.channelHomeType+"'}" : "{}",
            "channelHolidayStrategy": this.channelPeriod == "1" ? this.channelHolidayStrategy : "",
            "channelHolidayList": this.channelPeriod == "1" ? "{'list':'"+ (this.channelHolidayType == '1' ? this.channelHolidayNavList : this.channelHolidayEmpList) +"','type':'"+this.channelHolidayType+"'}" : "{}",
            "journalType": "系统管理=>会话配置=>渠道管理=>编辑",
            "menuId": "3_12-1-2"
          }
          let that = this;
          this.$http.post("chat/channel/doSave.json",param) .then(function (res) {
            let result=res.data;
            that.spinShow=false;
            if(result.flag!="666"){
              that.$Message.error(result.msg);
              return false;
            }
            that.$Message.success(result.msg);
            that.$emit("closeeditpublic",true);
          })
        },
        // 初始化查询
        initSearch: function(){
          let param = {
            id:this.searchId,
            channelType:'-8',
            journalType: "系统管理=>会话配置=>渠道管理=>查询",
            menuId: "3_12-1"
          }
          let that = this;
          this.$http.post("chat/channel/toIndex.json",param) .then(function (res) {
            let result = res.data;
            that.spinShow=false;
            if(result.flag!="666"){
              that.$Message.error(result.msg);
              return false;
            }
            that.channelURL = '';
            let channel = result.obj.list.content[0];
            that.channelNavList = result.obj.chatNavList;
            that.employeeList = result.obj.chatEmpList;

            that.channelName = channel.channelName;
            that.channelAppId = channel.channelAppId;
            that.channelAppSecret = channel.channelAppSecret;
            that.channelKey = channel.channelKey;
            that.channelWxToken = channel.channelWxToken;

            that.channelPeriod = channel.channelPeriod; //是否分时段
            that.channelURL = that.baseURL+'api/wxApiService/'+channel.channelWxToken;

            if (channel.channelAllocatStrategy){
              that.channelAllocatStrategy = channel.channelAllocatStrategy; //不开启分时段分配策略
            }else{
              that.channelAllocatStrategy = "1"; //不开启分时段分配策略
            }

            if(channel.channelAllocatList){
              that.channelAllocatType = JSON.parse(channel.channelAllocatList).type;
              if (that.channelAllocatType == '1'){
                that.channelAllocatNavList = JSON.parse(channel.channelAllocatList).list.split(',');
              }else{
                that.channelAllocatEmpList = JSON.parse(channel.channelAllocatList).list.split(',');
              }
            }else{
              that.channelAllocatType = "1";
              that.channelAllocatNavList = [];
              that.channelAllocatEmpList = [];
            }

            // 开启分时段策略
            //上班
            if (channel.channelWorkStrategy){
              that.channelWorkStrategy = channel.channelWorkStrategy;
            }else{
              that.channelWorkStrategy = "1";
            }

            if(channel.channelWorkList){
              that.channelWorkType = JSON.parse(channel.channelWorkList).type;
              if (that.channelWorkType == '1'){
                that.channelWorkNavList = JSON.parse(channel.channelWorkList).list.split(',');
              }else{
                that.channelWorkEmpList = JSON.parse(channel.channelWorkList).list.split(',');
              }
            }else{
              that.channelWorkType = "1";
              that.channelWorkNavList = [];
              that.channelWorkEmpList = [];
            }
            //下班
            if (channel.channelHomeStrategy){
              that.channelHomeStrategy = channel.channelHomeStrategy;
            }else{
              that.channelHomeStrategy = "1";
            }

            if(channel.channelHomeList){
              //下班
              that.channelHomeType = JSON.parse(channel.channelHomeList).type;
              if (that.channelHomeType == '1'){
                that.channelHomeNavList = JSON.parse(channel.channelHomeList).list.split(',');
              }else{
                that.channelHomeEmpList = JSON.parse(channel.channelHomeList).list.split(',');
              }
            }else{
              that.channelHomeType = "1";
              that.channelHomeEmpList = [];
              that.channelHomeNavList = [];
            }
            //节假日
            if (channel.channelHolidayStrategy){
              that.channelHolidayStrategy = channel.channelHolidayStrategy;
            }else{
              that.channelHolidayStrategy = "1";
            }

            if(channel.channelHolidayList){
              //节假日
              that.channelHolidayType = JSON.parse(channel.channelHolidayList).type;
              if (that.channelHolidayType == '1'){
                that.channelHolidayNavList = JSON.parse(channel.channelHolidayList).list.split(',');
              }else{
                that.channelHolidayEmpList = JSON.parse(channel.channelHolidayList).list.split(',');
              }
            }else{
              that.channelHolidayType = "1";
              that.channelHolidayEmpList = [];
              that.channelHolidayNavList = [];
            }
            if(channel.channelType == "-8"){
              that.title = "编辑公众号";
            }else if(channel.channelType == "-9"){
              that.title = "小程序";
            }
          })
        },

      },
      watch:{
        showeditpublic:function () {
          this.model = this.showeditpublic;
          let that = this;
          if(this.showeditpublic){
            this.initSearch();
          }
        }
      }
    }
</script>

<style scoped>
.select_cls{
  height: 30px !important;
  overflow-y:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/EditpublicPop.vue